// class to define constants for the entire GPT page
export const GPT_PAGE_CONSTANTS = {
	// The version of the GPT page
	VERSION: "1.0.0",
	// The title of the GPT page
	TITLE: "", // "Let Me Ask For You",
	// The text to display in the disclaimer
	DISCLAIMER:
		"This is a parodic website to troll your friends. It is not affiliated with OpenAI.",
	// The text to display in the query section
	QUERY_SECTION_TEXT: "Just GPT It",
	QUERY_SECTION_TEXT_2: "Show others how to use ChatGPT",
	// The text to display in the user icon
	USER_ICON_TEXT: "N",

	CREATOR_STATIC_RESPONSE: "The share-link was copied to your clipboard! Redirecting to ChatGPT in <> ...",
	CREATOR_STATIC_RESPONSE_NO_COUNTDOWN: "A share-link was copied to your clipboard!",
	RECEIVER_STATIC_RESPONSE: "That wasn't so hard, was it?\r\nRedirecting to ChatGPT in <> ...",
	RECEIVER_STATIC_RESPONSE_NO_COUNTDOWN: "This is how you use the internet to ask questions! Click the button below to go to ChatGPT and continue your chat there. Don't forget to show all of your friends that they too can justGptIt!",

	STATIC_RESPONSE_COUNTDOWN_START: 10,

	QUERY_PLACEHOLDER: "Show them how to ask, then share the link",
	QUERY_PLACEHOLDER_CHAT: "That wasn't so hard was it? Try one yourself and show your friends!",
	// QUERY_PLACEHOLDER: "Show them how to use the internet to ask questions",

	// The text to display on the back button
	BACK_BUTTON_TEXT: "New Question",
	OPEN_GPT_BUTTON_TEXT: "Go to ChatGPT",
	STOP_REDIRECTION_BUTTON_TEXT: "Stay Here",

	SHORT_URL_DEFAULT: "",

	POPUP_BLOCKED_MESSAGE: "",
	POPUP_BLOCKED_BUTTON_TEXT: "Click here if you are not redirected automatically",

	GO_TO_GPT_REDIRECTION_BUTTON_TEXT: "Open In ChatGPT",
	SHOW_ANIMATION_BUTTON_TEXT: "Show Animation",
	COPY_SHARE_LINK_BUTTON_TEXT: "Copy Share Link",
	COPIED_SHARE_LINK_BUTTON_TEXT: "Link Copied!",

	GOOGLE_ANALYTICS_MEASURMENT_ID: "G-2H5M5DPLEE",
};
